module.exports = __webpack_public_path__ + "img/hakkasan.8f27adb7.jpg";